'use strict';exports.__esModule = true;var mainImageLinkDesktop = 'https://res.cloudinary.com/onmap-prod/image/upload/q_auto,f_auto/v1613640758/foreign/1920x559px';
var mainImageLinkMobile = 'https://res.cloudinary.com/onmap-prod/image/upload/q_auto,f_auto/v1613640758/foreign/360x509px';

var getForeignPageMainImage = function getForeignPageMainImage(isMobile) {return isMobile ? mainImageLinkMobile : mainImageLinkDesktop;};exports.default =

getForeignPageMainImage;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ForeignPropertyPage/helpers.js
// module id = 2691
// module chunks = 0